import type { SiteSearchNotInstalledCustomSection, SuperApp } from '@wix/add-panel-common';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { useActionsDispatcher } from '../../../../../../ActionsDispatcher';
import { useCurrentCategory } from '../../../../../../CurrentCategoryProvider';
import { useUtils } from '../../../../../../UtilsProvider';
import { ActionItem } from '../../../components/ActionItem';
import styles from './SiteSearch.scss';
import type { SiteSearchProps } from './SiteSearch.types';

const useSearchAppInfo = (appDefinitionId: string): SuperApp => {
  const { getSuperAppData } = useUtils();

  const { data: searchApp } = useQuery<SuperApp>(
    ['search-app-info', appDefinitionId],
    () => getSuperAppData(appDefinitionId),
    {
      initialData: { colorSvgIcon: '', appIcon: '', name: '', teaser: '' },
    },
  );

  return searchApp!;
};

export const SiteSearch: FC<SiteSearchProps> = ({ section }) => {
  const { translate } = useUtils();
  const { dispatchComponentClick } = useActionsDispatcher();
  const category = useCurrentCategory();
  const { appDefinitionId, props } = section as SiteSearchNotInstalledCustomSection;

  const searchApp = useSearchAppInfo(appDefinitionId);

  return (
    <div>
      <ActionItem
        dataHook="site-search"
        title={searchApp.name}
        description={searchApp.teaser}
        illustration={<img className={styles.illustration} src={searchApp.colorSvgIcon || searchApp.appIcon} alt="" />}
        actionIcon={<Symbol name="plusBig" />}
        tooltipContent={translate('tpa_add_panel_add_to_site')}
        onClick={() => {
          dispatchComponentClick({
            category,
            section,
            customClickAndDropHandler: props.customClickAndDropHandler,
          });
        }}
        shouldTranslate={false}
      />
    </div>
  );
};
